<template>
    <v-col>
        <v-card :elevation="elevationProp" width="100%" :disabled="isLoading" :loading="isLoading">
            <v-card-title primary-title>
                <v-row>
                    <v-col cols="12" lg="10">
                        <div v-if="$vuetify.breakpoint.mdAndDown" class="primary--text text-overline text-center">
                            Agendados
                        </div>
                        <div v-else class="
                                font-weight-light
                                primary--text
                                text-h5 text-capitalize
                            ">
                            <v-icon large> mdi-calendar-month </v-icon>
                            Agendados
                        </div>
                    </v-col>
                    <v-col cols="12" lg="2" :class="
                        $vuetify.breakpoint.mdAndDown
                            ? 'd-flex justify-center align-center'
                            : 'd-flex justify-end align-center'
                    ">
                        <v-btn small color="green darken-1" outlined @click="goToCalendario">
                            Ir a mi calendario
                            <v-icon right> mdi-calendar </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>

            <!-- <v-divider class="test"></v-divider> -->

            <v-data-table :headers="headers" :items="agendados" :footer-props="footer_props" :items-per-page="8"
                class="elevation-0">
                <template v-slot:item.cliente.nombre="{ item }">
                    <p class="ma-0 font-weight-medium">
                        {{ item.cliente.nombre }}
                    </p>
                </template>
                atencion.cliente.tipo_documento
                <template v-slot:item.atencion.cliente.documento="{ item }">
                    <!-- {{
						item.atencion.cliente.tipo_documento
							? item.atencion.cliente.tipo_documento + ' - '
							: ''
					}} -->
                    {{ item.cliente.documento }}
                </template>
                <template v-slot:item.atencion.cliente.telefonos_contacto="{ item }">
                    <div class="d-flex justify-center">
                        <v-menu v-if="item.cliente.telefonos_contacto.length > 1" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="primary" v-bind="attrs" v-on="on">
                                    mdi-phone-plus
                                </v-icon>
                            </template>
                            <v-list>
                                <v-list-item v-for="(tlf, index) in item.cliente
                                .telefonos_contacto" :key="index">
                                    <v-list-item-title>{{
                                    tlf
                                    }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <div v-else>
                            {{ item.cliente.telefonos_contacto.toString() }}
                        </div>
                    </div>
                </template>
                <template v-slot:item.fecha_agendado="{ item }">
                    {{ fixDate(item.servicio.fecha_agendado) }}
                </template>

                <template v-slot:item.Actions="{ item }">
                    <div class="d-flex justify-center">
                        <div class="mr-2" md="3">
                            <v-btn class="d-flex grow justify-center flex-wrap" fab x-small color="primary" outlined
                                @click="showDialog('View', item.cliente)">
                                <v-icon> mdi-account </v-icon>
                            </v-btn>
                        </div>
                        <div md="3">
                            <v-btn class="d-flex grow justify-center flex-wrap" fab x-small color="orange" outlined
                                @click="showDialog('Edit', item.cliente)">
                                <v-icon> mdi-pen </v-icon>
                            </v-btn>
                        </div>
                    </div>
                </template>
                <template v-slot:item.servicio.is_attended="{item}">
                    <v-icon class="mr-1" :color="item.servicio.is_attended ? 'green': 'red'">mdi-circle</v-icon>
                </template>
            </v-data-table>
        </v-card>
        <EditDialog />
    </v-col>
</template>

<script>
import { mapState } from 'vuex';
import EditDialog from '../ComercialTeletrabajo/TtForm/CompleteViewTtFormDialog.vue';
import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';

export default {
    name: 'DashBoardScheduled',
    components: {
        EditDialog,
        LoadingSkeleton,
    },
    data: () => ({
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [8],
        },
        headers: [
            {
                text: 'Nombre',
                align: 'start',
                sortable: false,
                value: 'cliente.nombre',
            },
            { text: 'Documento', value: 'atencion.cliente.documento' },
            {
                text: 'Contacto',
                value: 'atencion.cliente.telefonos_contacto',
                sortable: false,
                align: 'center',
            },
            {
                text: 'Operador',
                sortable: false,
                value: 'cliente.isp_actual',
            },
            { text: 'Segmento', value: 'cliente.segmento', sortable: false },
            {
                text: 'Fecha agendado',
                value: 'fecha_agendado',
                sortable: false,
            },
            {
                text: 'Acciones',
                sortable: false,
                align: 'center',
                value: 'Actions',
                width: '150px',
            },
            {
                text: 'Atendido',
                sortable: false,
                align: 'center',
                value: 'servicio.is_attended',
            },
        ],
    }),
    props: {
        elevationProp: false,
    },
    computed: {
        ...mapState('dashboard', {
            agendados: (state) => state.estadisticaAgendados.agendados,
            isLoading: (state) => state.estadisticaAgendados.isLoading,
        }),
    },
    methods: {
        fixDate(date) {
            return `${new Date(date).toLocaleString('es', {
                day: 'numeric',
                month: 'long',
            })}`;
        },
        goToCalendario() {
            this.$router.push({ name: 'calendario' });
        },
        showDialog(action, cliente) {
            if (action == 'Edit')
                this.$store.dispatch('teletrabajo/editTtForm', cliente);
            else this.$store.dispatch('teletrabajo/viewTtForm', cliente);
        },
    },
};
</script>
